import { useEffect, useState } from "react";

import { Detector } from "types/detectors";

interface useAnnotationsProps {
  detectorFetchData?: Detector;
  fetchDetectorError?: Error;
  updateDetector: (arg: any) => Promise<Detector>;
}

export const useAnnotations = (props: useAnnotationsProps) => {
  const { detectorFetchData, fetchDetectorError, updateDetector } = props;
  const [annotations, setAnnotations] = useState<string[]>([""]);
  const [selectedAnnotation, setSelectedAnnotation] = useState<number | undefined>();
  const [enableAnnotations, setEnableAnnotations] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);

  useEffect(() => {
    if (detectorFetchData && !fetchDetectorError) {
      setAnnotations((prevAnnotations) => {
        if (prevAnnotations.length > 0 && prevAnnotations[0] !== "") return prevAnnotations;
        if (detectorFetchData.valid_bbox_labels === null || detectorFetchData.valid_bbox_labels.length === 0) {
          return [""];
        }
        return detectorFetchData.valid_bbox_labels;
      });
      setEnableAnnotations(detectorFetchData.labeling_task === "BOUNDING BOXES");
    }
  }, [detectorFetchData, fetchDetectorError]);

  const handleSwitchAnnotations = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEnableAnnotations(event.target.checked);
    updateAnnotationsFunc(annotations, event.target.checked);
  };

  const updateAnnotationsFunc = async (annotations: string[], enableAnnotations: boolean | null) => {
    const filterEmptyInputs = annotations.filter((item) => item.trim().length !== 0);
    setAnnotations([...filterEmptyInputs, ""]);
    await updateDetector({
      valid_bbox_labels: filterEmptyInputs.length > 0 ? filterEmptyInputs : [],
      labeling_task: enableAnnotations ? "BOUNDING BOXES" : "BINARY CLASSIFICATION",
    });
  };

  const handleRemoveInput = () => {
    const annotationsList = [...annotations];

    if (annotationsList.length === 1) {
      const defaultList = [""];
      setAnnotations(defaultList);
      setSelectedAnnotation(undefined);
      updateAnnotationsFunc(defaultList, enableAnnotations);
      setDeleteModalOpen(false);
      return;
    }

    const filterInput = [...annotations].filter((_, idx) => idx !== selectedAnnotation);
    setAnnotations(filterInput);
    setSelectedAnnotation(undefined);
    updateAnnotationsFunc(filterInput, enableAnnotations);
    setDeleteModalOpen(false);
  };

  return {
    deleteModalOpen,
    handleRemoveInput,
    handleSwitchAnnotations,
    enableAnnotations,
    annotations,
    setAnnotations,
    updateAnnotationsFunc,
    setDeleteModalOpen,
    setSelectedAnnotation,
  };
};
